<template>

	<div class="page-contacts flex column" id="page-contacts">

		<el-row  >
			<el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
				<div style="position:relative;float:right;">
					<el-button type="primary" @click="newContact()"  size="small" v-if="$can('write','Contacts')"><span class="hidden-md-and-down">Créer un contact</span><i class="el-icon-plus hidden-lg-and-up"></i></el-button>
				</div>
				<h2 class="mt-0" style="float:left;">{{ $t("contacts.title") }}</h2>

			</el-col>

		</el-row>

		<el-row :gutter="20">
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
				<!-- <el-tabs tab-position="top"  v-loading="loading">
					<el-tab-pane label="Toutes les fiches"> -->
						<el-input
							placeholder="Rechercher un contact"
							clearable
							v-model="contactSearch">
							<el-dropdown slot="append" style="border-right:1px;">
			            <el-button type="primary">
			            Trier par<i class="el-icon-arrow-down el-icon--right"></i>
			            </el-button>
			            <el-dropdown-menu slot="dropdown">
			            <el-dropdown-item :icon="sortIcon('createdAt')" @click.native="sortBy('createdAt')">Date de création</el-dropdown-item>
			            <el-dropdown-item  :icon="sortIcon('updatedAt')" @click.native="sortBy('updatedAt')">Dernière modification</el-dropdown-item>
			            <el-dropdown-item  :icon="sortIcon('last_name')" @click.native="sortBy('last_name')">Nom</el-dropdown-item>
			            </el-dropdown-menu>
			        </el-dropdown>
							<el-button slot="prepend" @click="showFilters=true"><i class="mdi mdi-filter-variant" style="font-size:15px;"></i></el-button>
						</el-input>
						<div class="contacts-list" style="margin:10px;">
							<el-pagination
									background
									v-if="$store.getters.contacts_pages>0 && contacts.length>0"
									:current-page.sync="currentPage"
									@current-change="handlePageChange"
									:page-size="totalPerPage"
									layout="total, prev, pager, next"
									small
									:pager-count="5"
									:total="total">
								</el-pagination>
								<div v-if="contacts.length==0 && !loading" style="text-align: center;margin-top:50px;">Aucun contact ne satisfait les critères de recherche</div>
								<div class="box grow scrollable only-y" :style="getHeightStyle">
									<div v-for="c in contacts" :key="c.id" class="flex contact" @click="openContact(c)" >
										<div class="star align-vertical p-10 fs-22">
												<i class="mdi mdi-account-circle align-vertical-middle"></i>
										</div>

										<div class="info box grow flex">
											<div class="name box grow flex column justify-center p-10">
												<div class="fullname fs-18" v-if="(c.first_name!=null && c.first_name!=='')|| (c.last_name!=null && c.last_name!=='')"><strong>{{c.first_name}} {{c.last_name}}</strong></div>
												<div v-else class="fullname fs-18">Unnamed contact</div>
												<div  style="margin-bottom:5px;margin-left:5px;padding-left:5px;" class="border-left">
														<div class="email fs-14 secondary-text" >{{getPhone(c)}}</div>
														<div v-for="(c, index) in c.companies" email fs-14 secondary-text>
															<div v-if="c.active">
																<span class=" fs-14 secondary-text" v-if="c.role">{{c.role}} @ {{c.company_usual_name!=null?c.company_usual_name:c.company_name}}</span>
																<span v-else class=" fs-14 secondary-text">{{c.company_usual_name!=null?c.company_usual_name:c.company_name}}</span>
															</div>
														</div>
													</div>
											</div>
											<div class="overdue p-10" style="text-align:right;">
												<span v-if="$store.getters.contactOrderBy['orderName']=='createdAt'" class="fs-14 secondary-text">Créé le {{moment(c.createdAt)}}<br></span>
												<span v-if="$store.getters.contactOrderBy['orderName']=='updatedAt'" class="fs-14 secondary-text">Mis à jour le {{moment(c.updatedAt)}}<br></span>
												<span class="align-vertical-middle fs-14 secondary-text">{{c.email}}</span></div>
										</div>
									</div>
								</div>
						</div>
					<!-- </el-tab-pane>
					<el-tab-pane label="Récemment modifiés">
					</el-tab-pane>
				</el-tabs> -->
			</el-col>
		</el-row>
		<contactFilter :visible="showFilters" direction="ltr" @close="showFilters=false"></contactFilter>
		<contactEditor :visible="showContactEditor" :contactToEdit="contactToEdit" @close="closeContactEditor"></contactEditor>
	</div>
</template>

<script>

// import InfoStatsCard from '@/components/Info-stat-card'
import axios from "axios";
import systemAPI from '@/services/API/system'
import { AsYouType } from 'libphonenumber-js'
import contactFilter from './components/contact-filter'
import moment from 'moment-timezone'
import contactEditor from '@/components/contact/contact-editor'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'Contacts',
	data() {
		return {
			showFilters : false,
			dialogvisible: false,
			showContactEditor : false,
			contactToEdit : null,
			window: {
				width: 0,
				height: 0
			}
		}
	},
	computed: {
		icons : {
			get(){return this.$store.getters.contactSortIcons}
		},
		orderBy : {
			set(val){this.$store.dispatch('CONTACT_CHANGE_ORDER_BY', val)},
			get(){return this.$store.getters.contactOrderBy}
		},sort_icon : {
			set(val){this.$store.dispatch('CONTACT_CHANGE_SORT_ICON', val)},
			get(){return this.$store.getters.contactSortIcon}
		},
		getHeightStyle(){
			return "height:" + (this.window.height-280) + "px;";
			// if(this.window.height<897){
			// 	return "height:" + (this.window.height-203) + "px;";
			// }else{
			// 	return "height:" + (this.window.height-340) + "px;";
			// }

		},
		total(){
			return this.$store.getters.contactSearch==""?this.$store.getters.contacts_length:this.$store.getters.contacts.length;
		},
		totalPerPage(){
			return this.$store.getters.contacts_per_page;
		},
		contactSearch : {
			set(val){this.$store.dispatch('CONTACTS_SEARCH_CONTACT', val)},
			get(){return this.$store.getters.contactSearch}
		},
		checkedActiveContacts : {
			set(val){this.$store.dispatch('CONTACTS_CHANGE_CONTACT_ACTIVE_FILTER', val)},
			get(){return this.$store.getters.checkedActiveContact}
		},
		currentPage : {
			set(val){},
			get(){return this.$store.getters.contacts_page}
		},
		contacts(){
			return this.$store.getters.contacts;
		},
		filterCollapse: {
			set(val){},
			get(){
				return null;
			}
		},
		loading() {
			return this.$store.getters.isContactLoading;
		},

	},
	methods: {
		closeContactEditor(){
			this.showContactEditor=false;
			this.contactToEdit=null;
		},
		moment(datetime){
			return  moment(datetime).format('LL');
		},
		sortBy(orderName){

			if(this.orderBy.orderName!=orderName){
				this.orderBy={orderName : orderName, direction:'ASC'};
				this.sort_icon = this.icons['ASC'];
			}else{
				if(this.orderBy.direction=='DESC'){
					this.orderBy={orderName : orderName, direction:'ASC'};
					this.sort_icon = this.icons['ASC'];
				}else{
					this.orderBy={orderName : orderName, direction:'DESC'};
					this.sort_icon = this.icons['DESC'];
				}
			}
		},
		sortIcon(orderName){
			return orderName==this.orderBy.orderName?this.sort_icon:'';
		},
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
		getPhone(contact){
      if (_.get(contact, 'phone') != null) {
        return new AsYouType('CA').input(_.get(contact, 'phone'));
      }
      return _.get(contact, 'phone');
		},
		handlePageChange(val) {
				this.$store.dispatch('CONTACTS_CHANGE_CONTACT_PAGE',val) // dispatch loading
    },
		getCompanies(contact){
			var companies = "";
			_.forEach(contact.companies, (cie, i)=>{
				if(i<3){
					if(i>0){companies+=", "}
					companies+=cie.company_name;

				}
			})
			if(contact.companies.length>3){
				companies+="...";
			}
			return companies;
		},
		openContact(contact){
			var index = '/contacts/' + contact.id;
			this.$router.push(index)
			this.$emit('push-page', {page:index})
		},
		newContact(data) {
			// var index = '/contacts/contact-form'
			// this.$router.push(index)
			// this.$emit('push-page', {page:index})
			this.showContactEditor=true;
		},
		...mapActions('controlData',['fetchCustomerClasses'])
	},
	mounted() {
		this.$store.dispatch('CONTACTS_LOAD_CONTACTS',1) // dispatch loading
		this.fetchCustomerClasses();
	},
	components: {
		// InfoStatsCard,
		contactFilter,
		contactEditor
	},
	created(){
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize)
	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.page-contacts {
	height: 100%;
	margin: 0 !important;
	padding: 20px;
	padding-bottom: 10px;
	box-sizing: border-box;

	.search-card {
		padding: 50px;
		// max-width: 350px;
		//max-height: 720px;
		box-sizing: border-box;
		margin-bottom: 15px;

		.el-input, .el-button {
			width: 100%;
		}
	}

	.search-wrap {
		margin: 0 auto;
		margin-bottom: 10px;
		padding: 0px 30px;
		box-sizing: border-box;
		width: 100%;
		// max-width: 600px;

		i {
			display: inline-block;
			width: 22px;
		}

		input {
			outline: none;
			background: transparent;
			border: none;
			font-size: 15px;
			position: relative;
			top: -2px;
			width: 100%;
			padding: 0;
			color: $text-color;
		}

		.contacts-tot {
			margin-right: 20px;
			margin-left: 10px;
		}

		a {
			border-bottom: 1px solid;
			text-decoration: none;
			color: $text-color;

			&:hover {
				opacity: .6;
			}
		}
	}

	.contacts-root {
		max-height: 100%;
	}

	.contacts-list {
		//margin: 0 auto;
		width: 100%;
		// max-width: 965px;
		padding: 0px 30px;
		box-sizing: border-box;

		.contact {
			margin: 10px 0;
			padding: 5px;
			box-sizing: border-box;
			cursor: pointer;
			transition: all .5s .25s;


			.star {
				.mdi-star {
					color: #ffd730;
				}
				.mdi-star-outline {
					opacity: .5;
				}
			}

			.avatar {
				width: 60px;
				transition: all .5s .25s;

				img {
					border: 1px solid transparentize($text-color, .9);
					box-sizing: border-box;
					width: 50px;
					height: 50px;
					border-radius: 50%;
					transition: all .5s .25s;
				}
			}

			.info {
				word-break: break-word;

				.name {

					//.fullname {}

					.email {
						opacity: 0;
						line-height: 0;
						transition: all .5s .25s;
					}

					//.phone {
					//	opacity: 0;
					//	line-height: 0;
					//	transition: all .5s .25s;
					//}

					//.phone {
					//	display: none;
					//}
				}

				//.phone {}
			}

			&:hover {
				//margin: 15px -20px;
				//padding: 10px;
				background-color: lighten($background-color, 20%);
				border-radius: 5px;
				box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);


				.avatar {
					width: 90px;

					img {
						width: 90px;
						height: 90px;
					}
				}

				.info {
					.name {
						.email {
							opacity: 1;
							line-height: 1.4;
						}

						.phone {
							opacity: 1;
							line-height: 1.4;
						}
					}
				}
			}
		}
	}

	.contacts-root {
		&.medium {
			.search-card {
				padding: 20px;
				max-width: 260px;
				max-height: 260px;
			}
		}
		&.small {
			overflow-y: auto;
			display: block;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			-ms-flex-direction: column;
			flex-direction: column;
			padding: 5px;

			.search-card {
				padding: 20px;
				max-width: 100%;
				width: 100%;
				//max-height: 240px;
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}

			.contacts-list {
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}
		}
	}
}


@media (max-width: 768px) {

	.page-contacts {
		.search-wrap {
			padding: 0;
		}
		.contacts-list {
			padding: 0px;

			.contact {
				.avatar {
					width: 40px;

					img {
						width: 40px;
						height: 40px;
					}
				}

				.info {
					.overdue {
						display: none;
						text-align:right;
						line-height:0.5em;
					}

					.name {
						.phone {
							display: block;
						}
					}
				}

				&:hover {
					margin: 15px 0px;

					.avatar {
						width: 60px;

						img {
							width: 60px;
							height: 60px;
						}
					}
				}
			}
		}

		.contacts-root {
			&.medium {
				.contacts-list {
					padding: 0 30px;
				}
			}
			&.small {
				.contacts-list {
					padding: 8px;
				}
			}
		}
	}
}
</style>
